import { Component, ChangeDetectionStrategy, Input, inject } from '@angular/core';

import { IrisDmsModalsSandbox } from '@iris/common/modules/dms/sandbox/dms-modals.sandbox';
import { DmsBaseFolderAction } from '../dms-base-folder-action';
import { switchMap, take, tap } from 'rxjs/operators';
import { IrisDmsFoldersSandbox } from '@iris/common/modules/dms/sandbox/dms-folders.sandbox';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgClass } from '@angular/common';
import { MatMenuItem } from '@angular/material/menu';
import { StrakitButtonComponent } from '@ngx-strakit/cdk/controls';
import { StrakitButtonPrefixDirective } from '@ngx-strakit/cdk';

@Component({
  selector: 'iris-dms-edit-folder-button',
  templateUrl: './dms-edit-folder-button.component.html',
  styleUrls: ['./dms-edit-folder-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgClass,
    MatTooltipModule,
    MatMenuItem,
    StrakitButtonComponent,
    StrakitButtonPrefixDirective,
  ],
})
export class IrisDmsEditFolderButtonComponent extends DmsBaseFolderAction {
  private readonly dmsModalsSandbox = inject(IrisDmsModalsSandbox);
  private readonly dmsFoldersSandbox = inject(IrisDmsFoldersSandbox);

  @Input() isAdd = false;

  private readonly addFolderLabel = 'label.NewFolder';
  private readonly folder = toSignal(this.folderId$.pipe(
    switchMap(folderId => this.dmsFoldersSandbox.getFolderById$(folderId)),
  ));

  private showAddFolderModal(): void {
    this.dmsModalsSandbox.showFoldersTreeModal({
      label: this.addFolderLabel,
      keepSelectedFolder: true,
      showSelectBtn: false,
    }).onSuccess$.pipe(
      take(1),
      tap((id: string) => this.dmsModalsSandbox.showAddFolderModal(id)),
    ).subscribe();
  }

  public openEditFolderModal(): void {
    if (this.isAdd) { return this.showAddFolderModal(); }
    this.dmsModalsSandbox.showEditFolderModal(this.folder());
  }

  get label(): string {
    return this.isAdd ? this.addFolderLabel : 'label.Edit';
  }
}
